import "idempotent-babel-polyfill";

import * as React from "react";
import * as ReactDOM from "react-dom";

import { App } from "./App";

const elementToMountReactAppOn = document.querySelector("[data-react-plp]");
if (elementToMountReactAppOn) {
  /**
   * If scrollRestoration is available in history, set it to `manual` to prevent
   * browser from restoring scroll position when the user returns from PDP, otherwise
   * scroll to top before window unloads to achieve the same effect. This is due
   * to the fact of race condition when browser and app both try to restore
   * the scroll position when the user returns from PDP, which causes inconsistent
   * behaviour
   */
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  } else {
    window.addEventListener("beforeunload", () => window.scrollTo(0, 0));
  }

  ReactDOM.render(
    <App mountElement={elementToMountReactAppOn} />,
    elementToMountReactAppOn
  );
}
